export const SET_DIMENSIONS_VARIABLES = 'SET_DIMENSIONS_VARIABLES'
export const SET_UNITES_AJOUTABLES = 'SET_UNITES_AJOUTABLES'
export const ADD_DIMENSION_VARIABLE = 'ADD_DIMENSION_VARIABLE'
export const DEL_DIMENSION_VARIABLE = 'DEL_DIMENSION_VARIABLE'

